import { NURSE_STATUS, USER_ROLES, ROUTE_PREFIX_PARAMS } from '@/utils/config';
import { useCustomerCancelStore } from '@/stores/customerCancel';
import { useCookie } from '@/utils/composables/useCookie';
import { useAuthStore } from '@/stores/auth';
import { useAppMessageStore } from '@/stores/appMessage';
const vtoken = import.meta.env.VITE_TOKEN;
const vuser = import.meta.env.VITE_USER;

// Route name do not need permissions
const whiteList = [
	'NotFound',
	'Login',
	'Register',
	'ResetPassword',
	'ForgotPassword',
	'AccountStatus',
	'Welcome',
	'CustomerLogin',
	'CustomerLoginLink',
	'NurseLoginLink',
	'CustomerRegister',
	'CustomerResetPassword',
	'CustomerForgotPassword',
	'CustomerWelcome',
	'CustomerVerification',
	'CustomerInformation',
	'CustomerStoryBrand',
	'CustomerNotification',
	'CustomerHome',
	'CustomerServiceDetail',
	'CustomerHealthTestingService',
	'CustomerServices',
	'CustomerSearch',
	'CustomerAbout',
	'CustomerServicesList',
	'CustomerBlogList',
	'CustomerBlogDetail',
	'CustomerQaHelp',
	'CustomerContact',
	'CustomerIntroStaff',
	'CustomerCCGQ',
	'CustomerCSBM',
	'CustomerQCHD',
	'CustomerCSVC',
	'CustomerCSHDV',
	'CustomerCSHT',
];

function isCustomerPublicHomePath(path) {
	if (path === '/') return true;
	const normalized = path.replace(/\/$/, '');
	return normalized === '/trang-chu';
}

export async function middlewareLayout(to, from, next) {
	try {
		const mode = localStorage.getItem('mode') || USER_ROLES.customer;
		if (mode === USER_ROLES.nurse && isCustomerPublicHomePath(to.path)) {
			next({ name: `${ROUTE_PREFIX_PARAMS.nurse}Home` });
			return;
		}

		const layout = to.meta.layout ?? 'Default';
		const theme = await import(`@/layouts/${layout}.vue`);
		to.meta.theme = theme.default;
		const token = useCookie(vtoken).value;
		const modePath = mode === USER_ROLES.nurse ? 'cong-tac-vien' : '';
		const currentUser = useCookie(vuser).value;
		const authStore = useAuthStore();
		const appMessageStore = useAppMessageStore();
		if (token) {
			const nameRoutes = [
				'Welcome',
				'Login',
				'ForgotPassword',
				'CustomerWelcome',
				'CustomerLogin',
				'CustomerRegister',
				'CustomerForgotPassword',
				'CustomerInformation',
			];
			if (nameRoutes.includes(to.name)) {
				if (mode === USER_ROLES.nurse) {
					next({ name: `${ROUTE_PREFIX_PARAMS.nurse}Home` });
				} else {
					next({ path: `/${modePath}` });
				}
			} else {
				if (to.name === 'CustomerLoginLink' || to.name === 'NurseLoginLink') {
					next();
					return 0;
				}

				if (mode === USER_ROLES.customer) {
					const user = authStore.user || currentUser || {};
					const phone = user.phone || '';

					if (
						typeof phone === 'string' &&
						phone.startsWith('tobeupdatedlater') &&
						to.name !== 'CustomerProfile'
					) {
						appMessageStore.setMessage('Vui lòng cập nhật số điện thoại của bạn.');
						next({ name: 'CustomerProfile' });

						return 0;
					}
				}

				if (
					mode === USER_ROLES.nurse &&
					currentUser.status === NURSE_STATUS.unauthenticated &&
					to.name !== `${ROUTE_PREFIX_PARAMS.nurse}Profile` &&
					to.name !== `${ROUTE_PREFIX_PARAMS.nurse}Home`
				) {
					next({ name: `${ROUTE_PREFIX_PARAMS.nurse}Home` });

					return 0;
				}

				next();
			}
		} else {
			if (Number(import.meta.env.VITE_CUSTOMER_OPEN) < 1 && (to.name === 'CustomerRegister' || to.name === 'CustomerLogin')) {
				const customerCancelStore = useCustomerCancelStore();
				customerCancelStore.showPopup();
				next({ path: '/' });
			} else if (whiteList.includes(to.name)) {
				next();
			} else next({ path: `/${modePath}` });
		}
	} catch (e) {
		console.log('Loader Default Layout', e);
		const theme = await import(`@/layouts/Default.vue`);
		to.meta.theme = theme.default;
		next();
	}
}
